import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { type FC, type ReactNode, useState } from 'react'

export interface ReactQueryProviderProps {
  children: ReactNode
}

export const ReactQueryProvider: FC<ReactQueryProviderProps> = ({ children }) => {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // With SSR, we usually want to set some default staleTime
            // above 0 to avoid refetching immediately on the client
            staleTime: 60 * 1000
          }
        }
      })
  )

  return (
    <QueryClientProvider client={client}>
      <ReactQueryDevtools
        buttonPosition='bottom-right'
        initialIsOpen={false}
      />
      {children}
    </QueryClientProvider>
  )
}
